<template>
  <div>
    <v-container fill-height fluid grid-list-xl class="pl-4 pt-0">
      <v-layout wrap>
        <v-flex>
          <div
            v-if="request && request.id"
            style="position: sticky; top: 0px; z-index: 10;"
          >
            <TicketViewHeader
              :initialData="{ ticket: request, technicianMode: true }"
            />

            <v-tabs v-model="activeTab">
              <v-tab :class="activeTab === 0 ? 'tab-active' : ''">
                View Ticket
              </v-tab>
              <v-tab :class="activeTab === 1 ? 'tab-active' : ''">
                Edit Ticket
              </v-tab>
              <v-tab :class="activeTab === 2 ? 'tab-active' : ''">
                View User
              </v-tab>
              <v-tab :class="activeTab === 3 ? 'tab-active' : ''">
                Resolution
              </v-tab>
              <v-tab :class="activeTab === 4 ? 'tab-active' : ''">
                Logs
              </v-tab>
            </v-tabs>
          </div>

          <v-tabs-items v-model="activeTab" class="pt-3">
            <v-tab-item>
              <v-layout v-if="request && request.id">
                <v-flex d-flex style="width: 700px;">
                  <v-card
                    style="border: 2px solid rgb(76, 175, 80); border-radius: 12px; width: 100%;"
                  >
                    <v-layout row align-center class="px-3">
                      <v-card-text>
                        <div
                          class="body-1 font-weight-light d-flex align-center"
                          style="flex-wrap: wrap; justify-content: space-between;"
                        >
                          <div
                            style="flex: 1 1 auto; min-width: 0; margin-right: 8px;"
                          >
                            Requested By:
                            <span class="font-weight-medium">
                              <a
                                @click="searchUserTickets"
                                title="Click to Search User Tickets"
                                >{{ request.requesterName }}</a
                              >
                            </span>

                            On:
                            <span class="font-weight-medium">{{
                              request.createdAt | time
                            }}</span>
                            User:
                            <span class="font-weight-medium">{{
                              meUsername
                            }}</span>
                            <span v-show="request.requesterEmailID">
                              Email:
                            </span>

                            <span class="font-weight-medium">{{
                              request.requesterEmailID
                            }}</span>
                            <!-- Site:
                            <span class="font-weight-medium">{{
                              request.requestSiteName
                            }}</span> -->
                            Create via:
                            <span class="font-weight-medium"
                              >{{ request.source }}
                              {{
                                request.itReceptionBy
                                  ? `: ${request.itReceptionBy}`
                                  : ""
                              }}</span
                            >
                          </div>
                          <span class="text-xs-right" style="flex: 0 0 auto;">
                            <v-btn
                              style="border: 1px solid #e0e0e0; border-radius: 6px; padding: 2px 8px; font-size: 13px; font-weight: 600; white-space: nowrap; display: inline-flex; align-items: center; gap: 3px;"
                              small
                              flat
                              color="success"
                              title="Reply to the ticket"
                              @click="openReplyDialog"
                            >
                              <v-icon small>mdi-reply</v-icon>
                              Reply
                            </v-btn>

                            <v-btn
                              style="border: 1px solid #e0e0e0; border-radius: 6px; padding: 2px 8px; font-size: 13px; font-weight: 600; white-space: nowrap; display: inline-flex; align-items: center; gap: 3px;"
                              small
                              color="success"
                              flat
                              title="Add Note"
                              @click="addNoteDialog = true"
                            >
                              <v-icon small>mdi-note-text</v-icon>
                              Add Note
                            </v-btn>
                          </span>
                        </div>

                        <HelpDeskConversations
                          ref="conversations"
                          :initialData="{
                            ticket: request,
                            technicianMode: true,
                          }"
                        />
                      </v-card-text>
                    </v-layout> </v-card
                ></v-flex>
                <v-flex
                  style="min-width: 450px; max-width: 450px; width: 450px;"
                >
                  <TicketDetailsPanel
                    :key="request.displayID"
                    :initialData="{ ticket: request, technicianMode: true }"
                    @updated="loadRequest"
                  />
                </v-flex>
              </v-layout>
              <v-layout
                v-else
                align-center
                justify-center
                column
                style="height:300px; gap:16px"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="56"
                ></v-progress-circular>
                <span class="subheading grey--text">Loading...</span>
              </v-layout>
            </v-tab-item>

            <v-tab-item>
              <v-flex xs8 class="pa-0">
                <HelpDeskTechnicianRequestEdit
                  v-if="activeEdit"
                  :initialData="{ ticket: request }"
                  @updated="loadRequest"
                  @cancel="activeTab = 0"
                />
              </v-flex>
            </v-tab-item>
            <v-tab-item>
              <v-layout row wrap v-if="activeUserView">
                <v-flex
                  xs4
                  v-for="_requester in requester"
                  :key="_requester.id"
                >
                  <ManageengineUserView
                    :initial-data="{ user: _requester, fromTicketTab: true }"
                    @updated="getManageengineUserInfo"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab-item>
              <v-layout row wrap v-if="activeResolution">
                <v-flex xs4>
                  <Resolution
                    :initial-data="{ ticket: request }"
                    @updated="loadRequest"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout row wrap v-if="activeLogs">
                <v-flex xs6>
                  <Logs :initial-data="{ ticket: request.displayID }" />
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="addNoteDialog" persistent max-width="700">
      <v-card style="border: 2px solid green;">
        <v-card-title>
          <span class="headline">Add Note</span>
          <span class="ml-3" color="grey--text"
            >Not visible for the users.
          </span>
        </v-card-title>
        <v-form ref="form">
          <v-container class="pb-0">
            <v-layout wrap class="pb-0">
              <v-flex xs12>
                <v-Textarea
                  rows="10"
                  v-model="addNoteDescription"
                  label="Write a Note"
                  outline
                  ref="addNote"
                ></v-Textarea>
              </v-flex>
            </v-layout>
          </v-container>

          <v-flex xs12 sm8 class="ml-3">
            <ManageengineUploadFiles
              v-if="request && request.id"
              ref="uploadFiles"
              :uploadUrl="
                `api/Manageengine/ManageengineUpload?manageengineID=${
                  request.manageengineID
                }&type=notes`
              "
              :files.sync="fileUploadList"
              :uploading.sync="uploading"
            />
          </v-flex>
          <v-card-actions class="py-0">
            <v-checkbox
              color="success"
              v-model="notifyTechnician"
              label="Email the technician"
            />
            <v-spacer></v-spacer>
            <v-btn color="default" @click="resetNoteForm" dark small
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="addNote"
              :disabled="!addNoteDescription || uploading"
              small
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="replyDialog" persistent max-width="800">
      <v-card style="border: 2px solid green;">
        <v-card-title class="pb-0">
          <span class="headline">Reply</span>
          <span class="ml-3" style="font-size: 12px; color: red;"
            >Visible for the users!
          </span>
        </v-card-title>
        <v-form ref="form">
          <v-layout wrap align-baseline class="px-3">
            <v-flex shrink>
              <span class="body-2 grey--text text--darken-1 mr-3"
                >To: <span style="color: red;">*</span></span
              >
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="toEmail"
                :rules="[rules.email]"
                placeholder="Enter the email address of the user to reply to"
                ref="toEmail"
                dense
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-container grid-list-md class="py-1">
            <v-layout wrap>
              <v-flex xs12>
                <div
                  contenteditable="true"
                  ref="reply"
                  class="reply-editor"
                  v-html="replyTemplate"
                  @input="updateReplyDescription"
                ></div>
              </v-flex>
            </v-layout>
          </v-container>

          <v-flex xs12 sm8 class="mt-2 ml-3">
            <ManageengineUploadFiles
              v-if="request && request.id"
              ref="uploadFiles"
              :uploadUrl="
                `api/Manageengine/ManageengineUpload?manageengineID=${
                  request.manageengineID
                }&type=notifications`
              "
              :files.sync="fileUploadList"
              :uploading.sync="uploading"
            />
          </v-flex>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>

            <v-btn color="default" @click="resetReplyForm" dark small
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="technicianReply"
              small
              :disabled="uploading"
              >Send</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <UserTicketsDialog
      v-if="SearchUserTickets"
      :initial-data="{
        manageengineUser: requester.find(
          (r) => r.id === this.request.requesterID
        ),
      }"
      @closed="SearchUserTickets = false"
    />
  </div>
</template>
<script>
import {
  getTechnician,
  linkifyPlainUrlsInHtml,
  priorityOptions,
} from "./helpDeskHelpers.js";
import UserTicketsDialog from "./UserTicketsDialog.vue";
import HelpDeskTechnicianRequestEdit from "./HelpDeskTechnicianRequestEdit.vue";
import ManageengineUserView from "./ManageengineUserView.vue";
import Resolution from "./Resolution.vue";
import Logs from "./Logs.vue";
import HelpDeskConversations from "./HelpDeskConversations.vue";
import TicketDetailsPanel from "./TicketDetailsPanel.vue";
import TicketViewHeader from "./TicketViewHeader.vue";
import ManageengineUploadFiles from "./ManageengineUploadFiles.vue";
export default {
  metaInfo() {
    return {
      title: `Support Ticket #${this.$route.params.id} | Technician`,
    };
  },
  components: {
    TicketViewHeader,
    HelpDeskConversations,
    UserTicketsDialog,
    HelpDeskTechnicianRequestEdit,
    ManageengineUserView,
    Resolution,
    Logs,
    TicketDetailsPanel,
    ManageengineUploadFiles,
  },
  data: () => ({
    activeTab: 0,
    loading: false,
    request: null,
    requester: null,
    SearchUserTickets: false,
    processing: false,
    reopenProcessing: false,
    meUsername: null,
    addNoteDialog: false,
    addNoteDescription: "",
    replyDialog: false,
    replyDescription: "",
    replyTemplate: "",
    regID: "",
    selectedStatus: "",
    showStatusDropdown: false,
    technicians: [],
    selectedTechnician: null,
    showTechnicianDropdown: false,
    technicianPointer: false,
    categories: [],
    selectedCategory: null,
    showCategoryDropdown: false,
    categoryPointer: false,
    priorityOptions: priorityOptions,
    selectedPriority: null,
    showPriorityDropdown: false,
    priorityPointer: false,
    activeEdit: false,
    activeUserView: false,
    activeResolution: false,
    activeLogs: false,
    notifyTechnician: false,
    toEmail: "",
    fileUploadList: [],
    uploading: false,
    rules: {
      required: (value) => !!value || "Required.",
      email: (v) =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "Enter a valid email",
    },
  }),

  watch: {
    "$route.params.id": {
      immediate: false,
      async handler() {
        this.loading = true;
        await this.load();
      },
    },
    activeTab: {
      immediate: true,
      handler(val) {
        this.activeEdit = val === 1;
        this.activeUserView = val === 2;
        this.activeResolution = val === 3;
        this.activeLogs = val === 4;
      },
    },
  },

  async created() {
    await this.load();
  },
  methods: {
    async load() {
      await this.loadRequest();
      this.activeTab = 0;
      this.getManageengineUserInfo();
    },

    async loadRequest() {
      try {
        const response = await this.$http.get(
          `api/manageengine/getRequestbyID?id=${this.$route.params.id}`
        );

        if (response.notFound) {
          this.$notify({
            text:
              "Ticket not found – it was probably deleted or merged with another request.",
            group: "notification",
            type: "error",
          });
          setTimeout(() => {
            this.$router.push("/helpdesk/technician/requests");
          }, "500");
          return;
        }
        this.request = response.request;
        this.meUsername = response.username;
        this.loading = false;
        this.activeTab = 0;
      } catch (e) {
        setTimeout(() => {
          this.$router.push("/helpdesk/technician/requests");
        }, "500");
      }
    },

    async getManageengineUserInfo() {
      try {
        const response = await this.$http.get(
          `api/manageengineUSers/getManageengineUserInfo?id=${
            this.request.requesterID
          }`
        );
        this.requester = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    searchUserTickets() {
      this.SearchUserTickets = true;
    },

    getTechnician() {
      return getTechnician(this.request);
    },

    async addNote() {
      try {
        const filesId = [];
        for (var i = 0; i < this.fileUploadList.length; i++) {
          filesId.push(this.fileUploadList[i].file_id);
        }
        const attachments = filesId[0] ? JSON.stringify(filesId) : "";

        this.processing = true;
        const desc = `${this.addNoteDescription}`;
        const description = linkifyPlainUrlsInHtml(
          desc.replace(/  /g, "&nbsp;").replace(/\n/g, "<br>")
        );

        const info = `<b>From: </b>${
          this.$store.state.authentication.user
        } <hr /><br>`;

        await this.$http.post(
          `api/Manageengine/AddNote?data=${encodeURIComponent(
            info + description
          )}&manageEngineID=${this.request.manageengineID}&displayID=${
            this.request.displayID
          }&notifyTechnician=${
            this.notifyTechnician
          }&attachments=${attachments}`
        );

        this.$notify({
          text: "Note added successfully",
          group: "notification",
          type: "success",
        });
        this.resetNoteForm();
        await this.$refs.conversations.updateConversationListAndNoteList();
      } catch (err) {
        console.error("Error adding note:", err);
        this.$notify({
          text: "massege not send",
          group: "notification",
          type: "error",
        });
      }
    },

    resetNoteForm() {
      this.processing = false;
      this.addNoteDialog = false;
      this.addNoteDescription = "";
      this.notifyTechnician = false;
      this.fileUploadList = [];
      this.uploading = false;
    },

    resetReplyForm() {
      this.processing = false;
      this.replyDialog = false;
      this.replyDescription = "";
      this.replyTemplate = "";
      this.toEmail = "";
      this.fileUploadList = [];
      this.uploading = false;
    },

    defaultReplyTemplate() {
      //   let html = `<b>From: </b>${this.$store.state.authentication.user
      //     .split("@")[0]
      //     .toUpperCase()}<hr />`;
      let html = `Dear ${
        this.request.requesterName
      }, <hr style="border-top: 1px solid #eee; margin: 5px 0;">`;
      html += `<b>Our Reply:</b><br><br><br><br><br><br><br><hr/>`;

      html += `Technician: ${
        this.getTechnician() == "This ticket has not yet been assigned" ||
        this.getTechnician() == ""
          ? ""
          : this.getTechnician()
      }<br>`;
      html += `Category: ${
        this.request.categoryName == "" ? "" : this.request.categoryName
      }<br>`;
      //html += `Description: ${this.request.description},<br>`;
      html += `<br>Regards,<br>Our HelpDesk`;
      return html;
    },

    openReplyDialog() {
      this.$refs.reply.innerHTML = this.replyTemplate = this.replyDescription = this.defaultReplyTemplate();
      this.replyDialog = true;
      this.toEmail = this.request.requesterEmailID;
    },

    async technicianReply() {
      if (!this.$refs.toEmail.validate(true)) {
        return;
      }
      try {
        const filesId = [];
        for (var i = 0; i < this.fileUploadList.length; i++) {
          filesId.push(this.fileUploadList[i].file_id);
        }

        this.processing = true;

        const from = `<b>From: </b>${this.$store.state.authentication.user
          .split("@")[0]
          .toUpperCase()}<hr />`;
        const description = linkifyPlainUrlsInHtml(this.replyDescription);

        await this.$http.post(`api/Manageengine/Reply`, {
          DisplayID: this.request.displayID,
          ManageengineID: this.request.manageengineID,
          Subject: `Re: [Request ID :##${this.request.displayID}##] : ${
            this.request.subject
          }`,
          Description: from + description,
          IsFromRequester: false, // false means the reply is from the technician
          technicianName: this.request.technicianName,
          toEmail: this.toEmail,
          attachments: filesId[0] ? JSON.stringify(filesId) : "",
        });
        this.$notify({
          text: "Reply sent successfully",
          group: "notification",
          type: "success",
        });
        this.resetReplyForm()
        await this.$refs.conversations.updateConversationListAndNoteList();
      } catch (error) {
        console.error("Error replying to ticket:", error);
        this.$notify({
          text: "Error replying to ticket",
          group: "notification",
          type: "error",
        });
      }
    },

    updateReplyDescription(e) {
      this.replyDescription = e.target.innerHTML;
    },
  },
};
</script>
<style>
.tab-active {
  background-color: rgb(76, 175, 80) !important;
  color: white !important;
  font-weight: 600 !important;
}

.ticket-header-nav {
  background-color: #e8e8e8 !important;
  border: 1px solid #d5d5d5 !important;
  color: rgb(11, 160, 16) !important;
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.reply-editor {
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  padding: 12px;
  min-height: 300px;
  font-size: 14px;
  line-height: 1.6;
  outline: none;
  overflow-y: auto;
}

.reply-editor:focus {
  border-color: #4caf50;
  border-width: 2px;
}
</style>
